import getHelper from '../../../services/getHelper';

export default getHelper('/assessments/:id');
